import React, { useEffect } from 'react';
import { useJackpotCurrency } from '@/widgets/jackpot-component/model/hooks';

function JackpotGameWidget() {
  const { isReady, currency, jackpotUrl, logo } = useJackpotCurrency();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = '/jackpot-components/components/jackpot-iife.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!isReady) return null;

  return (
    <vamos-jackpot-game
      url={jackpotUrl}
      currency={currency}
      logo={logo}
    ></vamos-jackpot-game>
  );
}

export default JackpotGameWidget;
